(function () {
  function initCart(section) {
    if (!section || section.dataset.initialized === 'true') return;

    var ajaxEnabled = section.dataset.ajaxEnabled === 'true';
    var errorEl = section.querySelector('[data-rng-cart-error]');
    var pending = false;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
    }

    function updateCart(lineItemKey, quantity) {
      if (!ajaxEnabled || pending) return;

      pending = true;
      errorEl && errorEl.classList.add('hidden');

      fetch((window.Shopify && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: quantity
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          window.location.reload();
        })
        .catch(function () {
          pending = false;
          showError('There was an error while updating your cart. Please try again.');
        });
    }

    section.querySelectorAll('[data-rng-cart-item]').forEach(function (row) {
      var lineItemKey = row.dataset.lineItemKey;
      var qtyInput = row.querySelector('[data-rng-cart-qty-input]');
      var decreaseBtn = row.querySelector('[data-rng-cart-qty-decrease]');
      var increaseBtn = row.querySelector('[data-rng-cart-qty-increase]');
      var removeBtn = row.querySelector('[data-rng-cart-remove]');

      if (!qtyInput || !lineItemKey) return;

      function applyQuantity(nextQuantity) {
        var quantity = Math.max(0, parseInt(nextQuantity, 10) || 0);
        qtyInput.value = quantity;
        updateCart(lineItemKey, quantity);
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          applyQuantity(parseInt(qtyInput.value, 10) - 1);
        });
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          applyQuantity(parseInt(qtyInput.value, 10) + 1);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          applyQuantity(0);
        });
      }

      if (ajaxEnabled) {
        qtyInput.addEventListener('change', function () {
          applyQuantity(qtyInput.value);
        });
      }
    });

    var noteField = section.querySelector('[data-rng-cart-note]');
    if (noteField && ajaxEnabled) {
      var noteTimer;

      noteField.addEventListener('input', function () {
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          fetch((window.Shopify && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ note: noteField.value })
          }).catch(function () {
            showError('There was an error while updating your cart. Please try again.');
          });
        }, 400);
      });
    }

    section.dataset.initialized = 'true';
  }

  function boot() {
    document.querySelectorAll('[data-rng-cart]').forEach(initCart);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
